import React, { useState } from 'react'

function AdminOfferReward() {
     const [image, setImage] = useState(null);
    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const imageUrl = URL.createObjectURL(file);
            setImage(imageUrl);
        }
    };

    return (
        <div className="p-6 min-h-screen flex flex-col items-center">
            <h2 className="text-2xl font-bold mb-4">REWARDS</h2>
            <div className="w-full max-w-md flex flex-col items-center">
                {/* <h3 className="text-lg font-semibold mb-2">Bank</h3> */}
                {image ? (
                    <img src={image} alt="Bank" className="w-full h-52 object-cover rounded-lg" />
                ) : (
                    <div className="w-full h-52 flex items-center justify-center bg-gray-200 text-gray-500 rounded-lg">
                        No Image
                    </div>
                )}
                <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    className="mt-2 cursor-pointer border border-gray-300 p-2 rounded"
                />
            </div>
        </div>
    );
}

export default AdminOfferReward